type Input = {
  key: string
}

export const tryRemoveFromLocalStorage = ({ key }: Input): void => {
  try {
    localStorage.removeItem(key)
  } catch (error) {
    console.error('Error removing item from localStorage', error, key)
  }
}
